import { render } from "./BottomPane.vue?vue&type=template&id=407cd88c&scoped=true"
import script from "./BottomPane.vue?vue&type=script&lang=js"
export * from "./BottomPane.vue?vue&type=script&lang=js"

import "./BottomPane.vue?vue&type=style&index=0&id=407cd88c&scoped=true&lang=scss"

import exportComponent from "V:\\Personal\\Projects\\Code\\Emotion-Based-Music-Streaming-App-WEB\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407cd88c"]])

export default __exports__